import { combineReducers } from 'redux'

import dashboard from "./dashboardReducer"
import verification from "./verificationReducer"
import deposit from "./depositReducer"
import status from "./statusReducer"
import settings from "./settingsReducer"

import modals from "./modalReducer"

export default combineReducers({
  modals, dashboard, verification, deposit, status, settings
})


// WEBPACK FOOTER //
// ./src/reducers/index.js